export default class Constants {
    static introductionVideoUrl: string = "https://www.youtube-nocookie.com/embed/dCJpyDfWilU" //Embed URL
    static introductionVideoLink: string = "https://www.youtube.com/watch?v=dCJpyDfWilU" //Link for Help Center
}
